import React from "react";
import { FormGroup } from "../../../components/form";
import { GetUserName, formatDate } from "../../CommonFunctions";
import * as Yup from "yup";

export const adminNotesForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "formArray",
      key: "adminNotes",
      autoAddField: true,
      mutateValues(formContext, initialValues, childModel) {
        if (!formContext.disabled && initialValues[0].note != "") {
          initialValues.unshift(childModel);
        }
        return initialValues;
      },
      fields: [
        {
          type: "component",
          body: ({ parentValues }) => (
            <div>
              {parentValues.initialNoteDate != undefined ? (
                <div className="notesValue w-full">
                  <div className="flex justify-content-between align-items-center">
                    <div>
                      {" "}
                      <span className="user-icon-black pr-2"></span>{" "}
                      <span>{parentValues.initialNoteUserCreated ? parentValues.initialNoteUserCreated : ""}</span>
                    </div>{" "}
                    <div>
                      <span className="time-stamp-black pr-2"></span>
                      <span> {parentValues.initialNoteDate ? formatDate(parentValues.initialNoteDate) : ""} </span>
                    </div>
                  </div>{" "}
                </div>
              ) : (
                <div></div>
              )}
            </div>
          ),
        },
        {
          type: "field",
          key: "note",
          fieldType: "textarea",
          props: {
            className: "mb-3",
            rows: 5,
            col: 30,
            autoResize: true,
          },
          label: "Administrative Notes",
          expressionProps: {
            disabled: (context, values, model, props) => {
              return values.adminNotes[props.index].dateCreated != null;
            },
          },
          validation: Yup.string().required("A response is required"),
        },
        {
          type: "field",
          key: "initialNoteUserCreated",
          fieldType: "input",
          defaultValue: GetUserName(),
          hideExpression() {
            return true;
          },
        },
      ],
    },
  ],
};
